import React, { useState, useEffect } from "react";
import {
    Container,
    Box,
    Typography,
    Button,
    Stack,
    Paper,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    CircularProgress,
    Modal,
    Select,
    MenuItem,
    InputLabel,
    FormControl
} from "@mui/material";
import { Add, } from "@mui/icons-material";
import Logocolor from "../Image/Logo.png";
import { FaTrashCan } from "react-icons/fa6";
import { Texto, buttonGuardar, SubTitulo, Input, buttonCancelar, modalStyle } from "../Layouts/CustomStyles";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUsuariosSistema, useGetRol } from "../Services/Perfil";
import { useGetSucursal } from "../Services/Sucursales";
import { PiLockKeyFill } from "react-icons/pi";

export const PaginaGestionUsuarios = () => {
    const { Rol } = useGetRol();
    const { sucursales } = useGetSucursal();
    const { getUsuarios, crearUsuario, eliminarUsuario, editarUsuario, cambiarEstadoUsuario, editarUsuariopassword } = useUsuariosSistema();
    const [openEliminarModal, setOpenEliminarModal] = useState(false);
    const [usuarioAEliminar, setUsuarioAEliminar] = useState(null);
    const [usuarios, setUsuarios] = useState([]);
    const [open, setOpen] = useState(false);
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [password, setPassword] = useState("");
    const [nuevoUsuario, setNuevoUsuario] = useState({
        name: "",
        email: "",
        role_id: "",
        sucursal: "",
        password: ""
    });
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    // Modal editar
    const [openEditarModal, setOpenEditarModal] = useState(false);
    const [usuarioAEditar, setUsuarioAEditar] = useState(null);
    const [usuarioEditado, setUsuarioEditado] = useState({
        name: "",
        email: "",
        role_id: "",
        sucursal: "",
        estado: ""
    });

    const handleOpenPasswordModal = (usuario) => {
  setUsuarioEditado(usuario);
  setPassword(""); // limpiar input
  setOpenPasswordModal(true);
};


const handleClosePasswordModal = () => {
  setOpenPasswordModal(false);
  setPassword("");
};
    // 🔹 Obtener usuarios al montar el componente
    useEffect(() => {
        fetchUsuarios();
    }, []);

    const fetchUsuarios = async () => {
        try {
            const data = await getUsuarios();
            setUsuarios(data);
        } catch (err) {
            setAlertMessage("Error al obtener usuarios");
            setErrorAlertOpen(true);
        }
    };
    const handleOpenEliminarModal = (usuario) => {
        setUsuarioAEliminar(usuario);
        setOpenEliminarModal(true);
    };

    const handleCloseEliminarModal = () => {
        setUsuarioAEliminar(null);
        setOpenEliminarModal(false);
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChange = (e) => {
        setNuevoUsuario({ ...nuevoUsuario, [e.target.name]: e.target.value });
    };

   

    const handleCrear = async () => {
        if (!nuevoUsuario.name.trim() || !nuevoUsuario.email.trim()) {
            setAlertMessage("El nombre y correo son obligatorios.");
            setErrorAlertOpen(true);
            return;
        }

        setEnviandoAlert(true);
        try {
            await crearUsuario({
                name: nuevoUsuario.name,
                email: nuevoUsuario.email,
                password: nuevoUsuario.password,
                sucursal: nuevoUsuario.sucursal || "General",
                role_id: nuevoUsuario.role_id,
            });

            setAlertMessage("Usuario creado exitosamente.");
            setSuccessAlertOpen(true);
            setOpen(false);
            setNuevoUsuario({ name: "", email: "", sucursal: "" });
            fetchUsuarios();
        } catch (err) {
            setAlertMessage(err || "Error al crear usuario");
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };

    const handleConfirmEliminar = async () => {
        if (!usuarioAEliminar) return;
        setEnviandoAlert(true);
        try {
            await eliminarUsuario(usuarioAEliminar.id);
            setEnviandoAlert(false);
            setAlertMessage("Usuario eliminado correctamente.");
            setSuccessAlertOpen(true);
            fetchUsuarios();
        } catch (err) {
            setEnviandoAlert(false);
            setAlertMessage(err || "Error al eliminar usuario");
            setErrorAlertOpen(true);
        } finally {
            handleCloseEliminarModal();
        }
    };

    const handleOpenEditarModal = (usuario) => {
        setUsuarioAEditar(usuario);
        setUsuarioEditado({
            name: usuario.name,
            email: usuario.email,
            role_id: usuario.role_id,
            sucursal: usuario.sucursal,
            estado: usuario.estado
        });
        setOpenEditarModal(true);
    };

    const handleCloseEditarModal = () => {
        setOpenEditarModal(false);
        setUsuarioAEditar(null);
    };

    const handleGuardarEdicion = async () => {
          setEnviandoAlert(true);
        try {
            await editarUsuario(usuarioAEditar.id, usuarioEditado);
              setEnviandoAlert(false);
            setAlertMessage("Usuario actualizado correctamente");
            setSuccessAlertOpen(true);
            fetchUsuarios();
        } catch (err) {
             setEnviandoAlert(false);
            setAlertMessage(err || "Error al editar usuario");
            setErrorAlertOpen(true);
        } finally {
             setEnviandoAlert(false);
            handleCloseEditarModal();
        }
    };

 const handleGuardar = async () => {
    if (!password.trim()) {
      setAlertMessage("La contraseña no puede estar vacía.");
      setErrorAlertOpen(true);
      return;
    }

     setEnviandoAlert(true);
    try {
      await editarUsuariopassword(usuarioEditado.id, { password });
      setAlertMessage("Contraseña actualizada correctamente.");
      setSuccessAlertOpen(true);
      setPassword("");
    setEnviandoAlert(false);
      fetchUsuarios();
      handleClosePasswordModal()
    } catch (err) {
      setAlertMessage(err || "Error al actualizar la contraseña");
      setErrorAlertOpen(true);
    } finally {
        setEnviandoAlert(false);
    }
  };

    return (
        <Container maxWidth="lg" sx={{ py: 5 }}>
            <Paper
                elevation={4}
                sx={{
                    p: 4,
                    borderRadius: "20px",
                    background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                }}
            >
                {/* Cabecera */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={4} flexWrap="wrap">
                    <Box display="flex" alignItems="center" gap={2}>
                        <img src={Logocolor} alt="Logo Clínica Activa" style={{ width: 55, height: 55, objectFit: "contain" }} />
                        <Typography variant="h5" sx={Texto}>
                            Usuarios Alemana Activa
                        </Typography>
                    </Box>

                    <Button variant="contained" startIcon={<Add />} sx={buttonGuardar} onClick={handleOpen}>
                        Crear usuario
                    </Button>
                </Box>

                {/* Encabezado tabla */}
                <Stack spacing={2} mb={1}>
                    <Paper
                        sx={{
                            p: 2,
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            background: "#2a8d74",
                            color: "#fff",
                            fontWeight: "600",
                        }}
                    >
                        <Box sx={{ display: "flex", width: 150, alignItems: 'center', justifyContent: 'center' }}>Usuario</Box>
                        <Box sx={{ display: "flex", width: 150, alignItems: 'center', justifyContent: 'center' }}>Correo</Box>
                        <Box sx={{ display: "flex", width: 150, alignItems: 'center', justifyContent: 'center' }}>Sucursal</Box>
                        <Box sx={{ display: "flex", width: 150, alignItems: 'center', justifyContent: 'center' }}>Estado</Box>
                        <Box sx={{ display: "flex", width: 150, alignItems: 'center', justifyContent: 'center' }}>Acciones</Box>
                    </Paper>
                </Stack>

                {/* Listado de usuarios */}
                <Stack spacing={2}>
                    {usuarios.length > 0 ? (
                        usuarios.map((u) => (
                            <Paper
                                key={u.id}
                                elevation={2}
                                sx={{
                                    padding: '20px 0px 20px 5px',
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                    background: "#fff",
                                    transition: "0.3s",
                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                        boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                                    },
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1} sx={{ width: 200 }}>
                                    <Avatar sx={{ bgcolor: "#635bff", color: "#fff" }}>
                                        {u.name?.charAt(0).toUpperCase()}
                                    </Avatar>
                                    <Box>
                                        <Typography sx={Texto}>{u.name}</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: "flex", gap: 1, width: 100, alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography sx={SubTitulo}>{u.email}</Typography></Box>
                                <Box sx={{ display: "flex", gap: 1, width: 100, alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography sx={SubTitulo}>{u.sucursal || "General"}</Typography></Box>
                                <Box sx={{ display: "flex", gap: 1, width: 100, alignItems: 'center', justifyContent: 'center' }}> 
                                    
                                     <Button
  onClick={async () => {
    try {
      await cambiarEstadoUsuario(u.id);
      fetchUsuarios();
    } catch (err) {
      setAlertMessage(err || "Error al cambiar estado");
      setErrorAlertOpen(true);
    }
  }}
  sx={{
    p: 1,
    fontWeight:'600',
    fontFamily: 'Poppins',
    textTransform: 'capitalize',
    backgroundColor: u.estado === "activo" ? "#97d5a0ff" : "#e99999ff", // verde claro / rojo
    color: u.estado === "activo" ? "#0e6e1bff" : "#921c1cff",
    '&:hover': {
      backgroundColor: u.estado === "activo" ? "#97d5a0ff" : "#e99999ff", // hover más claro
    },
  }}
>
  {u.estado === "activo" ? "Activo" : "Inactivo"}
</Button>
                                    </Box>
                                <Box sx={{ display: "flex", gap: 1, width: 150, alignItems: 'center', justifyContent: 'center' }}>
                                    <button className="edit-button" onClick={() => handleOpenPasswordModal(u)}>
                                        <PiLockKeyFill className="key-svgIcon" />
                                    </button>
                                    <button className="edit-button" onClick={() => handleOpenEditarModal(u)}>
                                        <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                            <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                                        </svg>
                                    </button>
                                    <button className="delete-button" onClick={() => handleOpenEliminarModal(u)}>
                                        <FaTrashCan className="delete-svgIcon" />
                                    </button>
                                </Box>
                            </Paper>
                        ))
                    ) : (
                        <Typography sx={{ textAlign: "center", color: "#888" }}>No hay usuarios registrados</Typography>
                    )}
                </Stack>

                {/* Dialog crear usuario */}
                <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                    <DialogTitle sx={Texto}>Crear nuevo usuario</DialogTitle>
                    <DialogContent>
                        <Stack spacing={2} sx={{ mt: 1 }}>
                            <TextField
                                sx={Input}
                                label="Nombre completo"
                                name="name"
                                value={nuevoUsuario.name}
                                onChange={handleChange}
                                fullWidth
                            />
                            <TextField
                                sx={Input}
                                label="Correo electrónico"
                                name="email"
                                value={nuevoUsuario.email}
                                onChange={handleChange}
                                fullWidth
                            />
                            <FormControl fullWidth sx={Input}>
                                <InputLabel id="sucursal-label">Sucursal</InputLabel>
                                <Select
                                    labelId="sucursal-label"
                                    name="sucursal"
                                    value={nuevoUsuario.sucursal}
                                    onChange={handleChange}
                                    label="Sucursal"
                                >
                                    <MenuItem value="">General</MenuItem> {/* opción por defecto */}
                                    {sucursales?.map((s) => (
                                        <MenuItem key={s.id} value={s.name}>
                                            {s.name} {/* ajusta según el campo de tu sucursal */}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth sx={Input}>
                                <InputLabel id="sucursal-label">Rol del Usuario</InputLabel>
                                <Select
                                    labelId="sucursal-label"
                                    name="role_id"
                                    value={nuevoUsuario.role_id}
                                    onChange={handleChange}
                                    label="rol"
                                >

                                    {Rol?.map((s) => (
                                        <MenuItem key={s.id} value={s.id}>
                                            {s.name} 
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                sx={Input}
                                label="Contraseña"
                                name="password"
                                value={nuevoUsuario.password}
                                onChange={handleChange}
                                type="password"
                                fullWidth
                            />
                        </Stack>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button sx={buttonCancelar} onClick={handleClose}>Cancelar</Button>
                        <Button variant="contained" sx={buttonGuardar} onClick={handleCrear}>
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openEliminarModal} onClose={handleCloseEliminarModal}>
                    <DialogTitle sx={Texto}>Eliminar Usuario</DialogTitle>
                    <DialogContent>
                        <Typography sx={SubTitulo}>
                            ¿Estás seguro de que deseas eliminar al usuario{" "}
                            <strong>{usuarioAEliminar?.name}</strong>?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseEliminarModal} sx={buttonGuardar}>
                            Cancelar
                        </Button>
                        <Button onClick={handleConfirmEliminar} sx={buttonCancelar}>
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openEditarModal} onClose={handleCloseEditarModal} fullWidth maxWidth="sm">
  <DialogTitle sx={Texto}>Editar Usuario</DialogTitle>
  <DialogContent>
    <Stack spacing={2} mt={1}>
      <TextField
       sx={Input}
        label="Nombre completo"
        name="name"
        value={usuarioEditado.name}
        onChange={(e) => setUsuarioEditado({ ...usuarioEditado, name: e.target.value })}
        fullWidth
      />
      <TextField
       sx={Input}
        label="Correo electrónico"
        name="email"
        value={usuarioEditado.email}
        onChange={(e) => setUsuarioEditado({ ...usuarioEditado, email: e.target.value })}
        fullWidth
      />
      <FormControl fullWidth sx={Input}>
  <InputLabel id="rol-label">Rol del Usuario</InputLabel>
  <Select
    labelId="rol-label"
    name="role_id"                 // ✅ mismo nombre
    value={usuarioEditado.role_id}   // ✅ mismo nombre
    onChange={(e) => setUsuarioEditado({ ...usuarioEditado, role_id: e.target.value })}
    label="Rol"
  >
    {Rol?.map((r) => (
      <MenuItem key={r.id} value={r.id}>
        {r.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>

      <FormControl fullWidth  sx={Input}>
        <InputLabel>Sucursal</InputLabel>
        <Select
          value={usuarioEditado.sucursal}
          onChange={(e) => setUsuarioEditado({ ...usuarioEditado, sucursal: e.target.value })}
        >
          <MenuItem value="">General</MenuItem>
          {sucursales?.map((s) => (
            <MenuItem key={s.id} value={s.name}>{s.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
   
    </Stack>
  </DialogContent>
  <DialogActions>
    <Button sx={buttonCancelar} onClick={handleCloseEditarModal}>Cancelar</Button>
    <Button sx={buttonGuardar} onClick={handleGuardarEdicion}>
      Guardar cambios
    </Button>
  </DialogActions>
</Dialog>

  <Dialog open={openPasswordModal} onClose={handleClosePasswordModal} fullWidth maxWidth="sm">
  <DialogTitle sx={Texto}>Editar contraseña de {usuarioEditado?.name}</DialogTitle>
  <DialogContent>
    <Stack spacing={2} sx={{ mt: 1 }}>
      <TextField
       sx={Input}
        label="Nueva contraseña"
        type="password"
        fullWidth
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </Stack>
  </DialogContent>
  <DialogActions sx={{ p: 2 }}>
    <Button onClick={handleClosePasswordModal} sx={buttonCancelar}>Cancelar</Button>
    <Button sx={buttonGuardar} onClick={handleGuardar} disabled={enviandoAlert}>
      {enviandoAlert ? <CircularProgress size={24} /> : "Guardar"}
    </Button>
  </DialogActions>
</Dialog>


                {/* Modales de feedback */}
                <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                    <Box sx={modalStyle}>
                        <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                            <IoClose />
                        </section>
                        <section style={{ textAlign: "center" }}>
                            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                            <p className="alert-text">{alertMessage}</p>
                        </section>
                    </Box>
                </Modal>

                <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                    <Box sx={modalStyle}>
                        <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                            <IoClose />
                        </section>
                        <section style={{ textAlign: "center" }}>
                            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                            <p className="alert-text">{alertMessage}</p>
                        </section>
                    </Box>
                </Modal>

                <Modal open={enviandoAlert}>
                    <Box sx={modalStyle}>
                        <section style={{ textAlign: "center", padding: "1rem" }}>
                            <CircularProgress style={{ color: "#2a8d74" }} />
                            <p className="alert-text">Procesando solicitud...</p>
                        </section>
                    </Box>
                </Modal>
            </Paper>
        </Container>
    );
};